import Button from '../../atoms/Button/Button';
import styles from './LeaveChoiceModal.module.scss';

/**
 * CPAYMENT-1730: выход со страницы после «Я оплатил» в DefaultTemplate.
 *
 * Кнопка «Отмена» на экране реквизита раньше сразу деклайнила заявку — вместе с уже переведёнными
 * деньгами. Отмену не отнимаем (клиент мог передумать и не платить), но разводим её с уходом:
 * ушёл к мерчанту — заявка живёт и закроется чеком или оператором, отменил — деклайн как прежде.
 *
 * Текст русский без i18n — правило шаблона (локализован только Pinco).
 */
const LeaveChoiceModal = ({
  onLeave,
  onCancelTicket,
  onStay,
}: {
  onLeave: () => void;
  onCancelTicket: () => void;
  onStay: () => void;
}) => (
  <div className={styles.overlay} onClick={onStay}>
    <div className={styles.box} onClick={(e) => e.stopPropagation()}>
      <p className={styles.text}>
        {'Вы отметили, что оплатили. Если перевод уже сделан — не отменяйте заявку: дождитесь проверки платежа или обратитесь в поддержку.\nЕсли вы передумали и деньги не переводили — отмените заявку.'}
      </p>
      <div className={styles.actions}>
        <Button variant='primary' onClick={onLeave} dataSentryElement='leave-to-merchant'>
          Вернуться в сервис
        </Button>
        <Button variant='secondary' onClick={onCancelTicket} dataSentryElement='leave-cancel'>
          Отменить заявку
        </Button>
        <button
          type='button'
          className={styles.stay}
          onClick={onStay}
          data-sentry-element='leave-stay'
        >
          Остаться на странице
        </button>
      </div>
    </div>
  </div>
);

export default LeaveChoiceModal;
